import React from 'react';
import { translate } from 'components/Translation';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import { BodyS } from 'components/Typography/Typography';
import DepartmentBadge from 'views/Users/Details/UserDetails/dialogs/subcomponents/DepartmentBadge';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDepartmentsProps {
	onClick: (deptId: string) => void;
	departments: SingleDepartment[];
	checked: string;
}

const Departments = ({ onClick, departments, checked }: IDepartmentsProps) => {
	const classes = useStyles();
	return departments?.length > 0 ? (
		<>
			<div className={classes.departmentHeader}>
				<BodyS>{translate('users.details.assignToDepartment')}</BodyS>
			</div>
			<div className={classes.departmentBadges}>
				{(departments || []).map((department) => (
					<DepartmentBadge
						key={department.deptId}
						name={department.name}
						hexColor={department.uiColor}
						checked={department.deptId === checked}
						onClick={() => onClick(department.deptId)}
					/>
				))}
			</div>
		</>
	) : (
		<BodyS color="disabled-light">{translate('users.details.noDepartments')}</BodyS>
	);
};

export default Departments;
